import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { WithTooltip } from 'src/components';
import { FormLabel } from 'src/components/Forms/FormLabel/form-label';
import { SidePanelCaption } from 'src/components/SidePanelCaption';
import { SidePanelRow } from 'src/components/SidePanelRow';
import { componentsFontSizes } from 'src/constants/layout';
import { useCopyToClipboard } from 'src/utils/hooks';
import { PartnerTabContactPartner } from './partner-contact-info';

interface PartnerTabProps {
  partner: PartnerTabContactPartner | null;
}

export const PartnerInfo = ({ partner }: PartnerTabProps) => {
  const { copyToClipboard } = useCopyToClipboard();

  const conversationPartnerInfo = useMemo(() => {
    if (!partner) {
      return [];
    }

    return [
      {
        label: 'Support Phone',
        value: partner.supportPhone,
      },
      {
        label: 'Support Email',
        value: partner.supportEmail,
      },
      {
        label: 'Support Live Date',
        value: partner.supportLiveDate,
        hideTooltip: true,
      },
      {
        label: 'LitS Date',
        value: partner.litsDate,
        hideTooltip: true,
      },
    ];
  }, [partner]);

  return (
    <Stack>
      <SidePanelCaption sx={{ paddingTop: '0.5rem', paddingBottom: '0.25rem' }}>
        General Information
      </SidePanelCaption>
      <Stack>
        {conversationPartnerInfo.map((field) => (
          <SidePanelRow spacing={2} justifyContent="space-between" key={field.label}>
            <FormLabel label={field.label} sx={{ width: 'auto' }} />
            <WithTooltip hideTooltip={field.hideTooltip} title="Click to copy">
              <Typography
                variant="body2"
                sx={{
                  cursor: field.hideTooltip ? 'initial' : 'pointer',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontSize: componentsFontSizes.input,
                }}
                onClick={async () => {
                  if (field.value) {
                    await copyToClipboard(field.value);
                  }
                }}
              >
                {field.value}
              </Typography>
            </WithTooltip>
          </SidePanelRow>
        ))}
      </Stack>
    </Stack>
  );
};
